// src/pages/Shop.js
import React, { useContext, useEffect, useState } from "react";
import "../styles/shop.css";
import axios from "axios";
import { LanguageContext } from "../contexts/LanguageContext";
import ProductCard from "../common/product_card";
import FilterShop from "../common/filter_shop";
import Pagination from "../common/Pagination ";
import { useTranslation } from "react-i18next";
import ProductDetailsPopup from "../common/product_details_popup";
import { AppContext } from "../contexts/AppContext";
import { useParams } from 'react-router-dom';
import { ThemeContext } from "../contexts/ThemeContext";


function Shop() {
  const { factoryId } = useParams();
  const { language } = useContext(LanguageContext);
  const { searchKey, setSearchKey, filters, setFilters, BASE_URL } = useContext(AppContext);
  const { theme } = useContext(ThemeContext);


  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(15);
  const [first, setFirst] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { t } = useTranslation("home");


  const fetchProducts = async (page = 1, currentFilters = filters) => {
    setLoading(true);
    try {
      // const searchKey='';
      const params = new URLSearchParams();
      params.append("page", page);
      if (factoryId) {
        params.append("client_id", factoryId);
      }
      if (searchKey) {
        params.append("search_key", searchKey);
      }
      const subcategoryIds = Object.values(currentFilters)
        .flat()
        .filter(id => {
          // Check if this ID is not a parent category ID
          return !Object.keys(currentFilters).includes(id.toString());
        });

      // Add each subcategory ID as separate parameter
      if (subcategoryIds.length > 0) {
        subcategoryIds.forEach(id => {
          params.append("subcategory_ids[]", id);
        });
      }

      const response = await axios.get(`${BASE_URL}/products`, {
        params,
        paramsSerializer: params => params.toString(),
      });
      if (response.data?.data) {
        setProducts(response.data.data.data);
        setTotalRecords(response.data.data.total);
        setRows(response.data.data.per_page);
        setCurrentPage(response.data.data.current_page);
        setFirst((response.data.data.current_page - 1) * response.data.data.per_page);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = event => {
    const newPage = Math.floor(event.first / event.rows) + 1;
    setFirst(event.first);
    fetchProducts(newPage, filters);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    console.log(filters);

    fetchProducts(1, filters);
  }, [filters, searchKey]);

  const [selectedProduct, setSelectedProduct] = useState(null); // Add this state
  const [animationState, setAnimationState] = useState('');


  const handleProductClick = product => {
    setSelectedProduct(product);
    document.body.style.overflow = "hidden"; // Prevent scrolling when popup is open
  };

  const handleClosePopup = () => {
    setSelectedProduct(null);
    document.body.style.overflow = "auto"; // Re-enable scrolling
  };


  //   ===================== Handler for clearing all filters  ===================================
  const handleClearAll = () => {
    setFilters({});
    setSearchKey('');
  };


  const handleOpen = () => {
  setShowFilterPopup(true);
  setAnimationState('opening');
};

const handleClose = () => {
  setAnimationState('closing');
  setTimeout(() => {
    setShowFilterPopup(false);
    setAnimationState('');
  }, 300); // Match animation duration
};



  const [showFilterPopup, setShowFilterPopup] = useState(false);
  return (
    <div className='shop-container row justify-content-center'>
      <div className='filter_icon_parent' onClick={handleOpen}>
        <div className='filter_icon'  >
          <img src={`/assets/images/${theme}/filter.svg`} className='' alt='filter icon' />
        </div>
        <div className='filter_title'>{t('filters')}</div>
      </div>

                <div className='shop_search '>
              <input
                type='text'
                id='shops'
                className=''
                placeholder='Search Product'
                value={searchKey}
                onChange={e => setSearchKey(e.target.value)}
              />
       
          </div>

      {window.innerWidth <= 768 ? (
        showFilterPopup && (
          <div className={`filter-popup ${animationState}`}>
            <div className="w-100 d-felx justify-content-end">
              
              <button className="close-btn" onClick={handleClose}>X</button>

            </div>
            <FilterShop
              filters={filters}
              setFilters={setFilters}
              language={language}
              t={t}
            />
          </div>
        )
      ) : (
        <FilterShop
          filters={filters}
          setFilters={setFilters}
          language={language}
          t={t}
          className="col-2"
        />
      )}


      {/* ============================= Products section ========================== */}

      <div className='products-section col-11 col-md-10 col-md-10 row'>
        {loading ? (
          <div className='loading-indicator'>
            <img src='/assets/images/white/logo.gif' alt='Loading...' />
          </div>
        ) : products.length > 0 ? ( // ✅ No extra { } here
          <>
            <div className='row'>
              <div className='products_numbers'>
                {t("showing")} {first + 1}-{first + 15} {t("of")} {totalRecords} {t("result")}
              </div>
              <div className='products_seprator'></div>
              {products.map(product => (
                <ProductCard
                  key={product.id}
                  product={product}
                  language={language}
                  t={t}
                  onClick={() => handleProductClick(product)}
                />
              ))}
            </div>
            <Pagination
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
              currentPage={currentPage}
              loading={loading}
            />
          </>
        ) : (

          <div className="empty-state">
            <h2 className="no_product">No Products Found</h2>
            <p>Please try different filters or check back later.</p>
            <button
              onClick={() => handleClearAll()}
              className="retry-button"
            >
              Retry
            </button>
          </div>
        )}
      </div>
      <ProductDetailsPopup product={selectedProduct} onClose={handleClosePopup} language={language} />
    </div>
  );
}

export default Shop;
